module.exports = __webpack_public_path__ + "img/card-buy.40d98e82.png";